// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPasswordResetLinkValidationResponseDto
 */
export interface IPasswordResetLinkValidationResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IPasswordResetLinkValidationResponseDto
     */
    valid?: boolean;
}

/**
 * Check if a given object implements the IPasswordResetLinkValidationResponseDto interface.
 */
export function instanceOfIPasswordResetLinkValidationResponseDto(value: object): value is IPasswordResetLinkValidationResponseDto {
    return true;
}

export function IPasswordResetLinkValidationResponseDtoFromJSON(json: any): IPasswordResetLinkValidationResponseDto {
    return IPasswordResetLinkValidationResponseDtoFromJSONTyped(json, false);
}

export function IPasswordResetLinkValidationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPasswordResetLinkValidationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'valid': json['valid'] == null ? undefined : json['valid'],
    };
}

export function IPasswordResetLinkValidationResponseDtoToJSON(json: any): IPasswordResetLinkValidationResponseDto {
    return IPasswordResetLinkValidationResponseDtoToJSONTyped(json, false);
}

export function IPasswordResetLinkValidationResponseDtoToJSONTyped(value?: IPasswordResetLinkValidationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valid': value['valid'],
    };
}

